import { MarketTypes } from './types';

export const getClientFilters = (companyId: number) => ({
  types: [
    MarketTypes.GET_FILTERS_REQUEST,
    MarketTypes.GET_FILTERS_SUCCESS,
    MarketTypes.GET_FILTERS_FAILURE,
  ],
  promise: (client: any) => client.get('/mercado/get_client_filters', { params: { companyId } }),
});

export const searchFilters = (params: object) => ({
  types: [MarketTypes.SEARCH_REQUEST, MarketTypes.SEARCH_SUCCESS, MarketTypes.SEARCH_FAILURE],
  promise: (client: any) =>
    client.get('/mercado/search.json', {
      params,
    }),
});

export const searchBuyers = (params: object, page: number) => ({
  types: [
    MarketTypes.SEARCH_BUYERS_REQUEST,
    MarketTypes.SEARCH_BUYERS_SUCCESS,
    MarketTypes.SEARCH_BUYERS_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/mercado/search_buyers.json?page=${page}`, {
      params,
    }),
});

export const searchProviders = (params: object, page: number) => ({
  types: [
    MarketTypes.SEARCH_PROVIDERS_REQUEST,
    MarketTypes.SEARCH_PROVIDERS_SUCCESS,
    MarketTypes.SEARCH_PROVIDERS_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/mercado/search_providers.json?page=${page}`, {
      params,
    }),
});

export const getFilterOptions = (filter_id: number, companyId: number) => ({
  types: [
    MarketTypes.GET_FILTER_OPTIONS_REQUEST,
    MarketTypes.GET_FILTER_OPTIONS_SUCCESS,
    MarketTypes.GET_FILTER_OPTIONS_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/mercado/get_filter_options.json', {
      params: { filter_id, companyId },
    }),
});

export const getPublicBody = (public_body_id: number) => ({
  types: [
    MarketTypes.GET_PUBLIC_BODY_REQUEST,
    MarketTypes.GET_PUBLIC_BODY_SUCCESS,
    MarketTypes.GET_PUBLIC_BODY_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/mercado/get_public_body.json', {
      params: { public_body_id },
    }),
});

export const getBiddings = (orgao_id: number, params: object) => ({
  types: [
    MarketTypes.GET_BIDDINGS_REQUEST,
    MarketTypes.GET_BIDDINGS_SUCCESS,
    MarketTypes.GET_BIDDINGS_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/mercado/get_biddings.json?orgao_id=${orgao_id}`, {
      params,
    }),
});

// string: CNPJ com zero à esquerda não sobrevive a Number().
export const getCompanyData = (cnpj: number | string) => ({
  types: [
    MarketTypes.GET_COMPANY_DATA_REQUEST,
    MarketTypes.GET_COMPANY_DATA_SUCCESS,
    MarketTypes.GET_COMPANY_DATA_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/mercado/company', {
      params: { cnpj },
    }),
});

export const getProviderBiddings = (cnpj: number | string, page: number) => ({
  types: [
    MarketTypes.GET_PROVIDER_BIDDINGS_REQUEST,
    MarketTypes.GET_PROVIDER_BIDDINGS_SUCCESS,
    MarketTypes.GET_PROVIDER_BIDDINGS_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/mercado/search_provider', {
      params: { cnpj, page },
    }),
});

export const getCertidoes = (cnpj: number) => ({
  types: [
    MarketTypes.GET_CERTIDOES_REQUEST,
    MarketTypes.GET_CERTIDOES_SUCCESS,
    MarketTypes.GET_CERTIDOES_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/mercado/certidoes', {
      params: { cnpj },
    }),
});

export const getResults = (params: object, page: number) => ({
  types: [
    MarketTypes.GET_RESULTS_REQUEST,
    MarketTypes.GET_RESULTS_SUCCESS,
    MarketTypes.GET_RESULTS_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/mercado/results?page=${page}`, {
      params,
    }),
});

export const productsServices = (params: object, page: number) => ({
  types: [
    MarketTypes.PRODUCTS_SERVICES_REQUEST,
    MarketTypes.PRODUCTS_SERVICES_SUCCESS,
    MarketTypes.PRODUCTS_SERVICES_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/mercado/products_services?page=${page}`, {
      params,
    }),
});

export const getFollowups = (params: object, page: number) => ({
  types: [
    MarketTypes.GET_FOLLOWUPS_REQUEST,
    MarketTypes.GET_FOLLOWUPS_SUCCESS,
    MarketTypes.GET_FOLLOWUPS_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/mercado/followups?page=${page}`, {
      params,
    }),
});

export const getResultBidding = (bidding_id: string) => ({
  types: [
    MarketTypes.GET_RESULT_BIDDING_REQUEST,
    MarketTypes.GET_RESULT_BIDDING_SUCCESS,
    MarketTypes.GET_RESULT_BIDDING_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/mercado/get_result_bidding.json', {
      params: { bidding_id },
    }),
});
